import React from "react";
import mailImg from "../assets/images/subscribe.png";
import { MdOutlineEmail } from "react-icons/md";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../axiosInstance";
import { useNavigate } from "react-router-dom";

let SubscriptionSchema = object({
  email: string()
    .email("Invalid email address (must include '@')")
    .required("Email is required"),
});

export function Mail() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: SubscriptionSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formattedValues = {
          ...values,
        };

        const { data } = await axiosInstance.post(
          "/subscription",
          formattedValues
        );

        if (data.status === 200) {
          toast.success(data.message || "Mail Subscription Confirmed!");

          resetForm();
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });
  const handleSecureSubmit = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    if (token) {
      formik.handleSubmit();
    } else {
      navigate("/login");
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="MailContainer">
        <div className="mail-img">
          <img src={mailImg} />
        </div>
        <div className="mail-content">
          <div className="mail-join">Join Our Newsletter</div>
          <div className="mail-stay">
            Stay on top of out product releases, events, promotions & more!
          </div>
          <form onSubmit={handleSecureSubmit}>
            <div className="input-container">
              <div className="grouping-icon">
                <span className="mail-icon">
                  <MdOutlineEmail />
                </span>
                <input
                  type="email"
                  placeholder="Email address"
                  id="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
              </div>
              <div className="btnSubscribe">
                <button type="submit">Subscribe</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
